import React, { createContext, useContext, useState, ReactNode } from 'react';

export type TimeGranularity = 'day' | 'week' | 'month' | 'quarter' | 'year';

interface GranularityContextType {
  granularity: TimeGranularity;
  setGranularity: (granularity: TimeGranularity) => void;
}

const GranularityContext = createContext<GranularityContextType | undefined>(undefined);

interface GranularityProviderProps {
  children: ReactNode;
}

export function GranularityProvider({ children }: GranularityProviderProps) {
  const [granularity, setGranularity] = useState<TimeGranularity>('month');

  return (
    <GranularityContext.Provider value={{ granularity, setGranularity }}>
      {children}
    </GranularityContext.Provider>
  );
}

export function useGranularity() {
  const context = useContext(GranularityContext);
  if (context === undefined) {
    throw new Error('useGranularity must be used within a GranularityProvider');
  }
  return context;
}

// Labels for display
export const GRANULARITY_LABELS: Record<TimeGranularity, string> = {
  day: 'Day',
  week: 'Week',
  month: 'Month',
  quarter: 'Quarter',
  year: 'Year',
};

// Short labels for compact display
export const GRANULARITY_SHORT_LABELS: Record<TimeGranularity, string> = {
  day: 'D',
  week: 'W',
  month: 'M',
  quarter: 'Q',
  year: 'Y',
};
